import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';

export const Agricultural = (props) => {
  const handleBeneficiaries = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        landuse_and_beneficiaries: {
          ...prevFormData.info.landuse_and_beneficiaries,
          agricultural: Number(value),
        },
      },
    }));
  };

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>8.5</span>
          <span className="star">*</span>
        </div>
)}
      titleUA="Сільське господарство"
      titleEN="Agricultural"
      children={(
        <div className="flex-group">
          <input
            placeholder="0"
            id="agricultural"
            className="number"
            name="agricultural"
            value={props.formData.info.landuse_and_beneficiaries.agricultural}
            autoComplete="off"
            options={{
              numericOnly: true,
              stripLeadingZeroes: true,
            }}
            onChange={(e) => {
              const newValue = Number(e.target.value);
              const total = props.checkPercent('agricultural') + newValue;
              if (total <= 100) {
                handleBeneficiaries(newValue);
              } else {
                e.preventDefault();
              }
            }}
          />
          <span>%</span>
        </div>
)}
    />
  );
};
